import styles from "./GenerateReport.module.scss";
import { Iframe } from "@medoma/components/Iframe/Iframe";
import { getPatientApiUrl } from "@/Utils/EnvUtils";
import { useUserProfile } from "@/api/Users";
import { useLingui } from "@lingui/react/macro";
import { useSelectedSite } from "@/Utils/useSelectedSite";

export const GenerateReport = () => {
  const { t } = useLingui();
  const { organization } = useUserProfile();
  const site = useSelectedSite();
  if (site === null) {
    throw new Error("Should have selected site when generating a report");
  }

  return (
    <div className={styles.container}>
      <Iframe
        title={t`Generera rapport`}
        src={`${getPatientApiUrl(organization)}/htmx/center/${site}/report`}
        loadingMessage={t`Hämtar rapporter`}
        padding={24}
      />
    </div>
  );
};
